import { useState } from "react";
import { Link } from "react-router-dom";

// @mui material components
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

// Layout
import BasicLayout from "layouts/authentication/components/BasicLayout";

// Image
import bgImage from "assets/images/bg-sign-in-basic.jpg";

// Auth instance
import auth from "../../../../apis/authInstance";

function Cover() {
  const [email, setEmail] = useState("");
  const [code, setCode] = useState("");
  const [newPassword, setNewPassword] = useState("");

  const [step, setStep] = useState(1); // 1 = request, 2 = confirm
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleResetRequest = async () => {
    setLoading(true);
    setError("");
    setSuccess("");

    const res = await auth.resetPassword(email);

    setLoading(false);

    if (res.success) {
      setStep(2);
      setSuccess("Verification code sent to your email.");
    } else {
      setError(res.errorMessage);
    }
  };

  const handleCompleteReset = async () => {
    setLoading(true);
    setError("");
    setSuccess("");

    const res = await auth.completeReset(email, code, newPassword);

    setLoading(false);

    if (res.success) {
      setSuccess("Password reset successfully.");
    } else {
      setError(res.errorMessage);
    }
  };

  return (
    <BasicLayout image={bgImage}>
      <Card>
        <MDBox
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          mx={2}
          mt={-3}
          py={2}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h3" color="white">
            Reset Password
          </MDTypography>
          <MDTypography variant="button" color="white">
            {step === 1
              ? "You will receive an email with a verification code"
              : "Enter the code and your new password"}
          </MDTypography>
        </MDBox>

        <MDBox pt={4} pb={3} px={3}>
          {/* ERROR */}
          {error && (
            <MDTypography color="error" textAlign="center" mb={2}>
              {error}
            </MDTypography>
          )}

          {/* SUCCESS */}
          {success && (
            <MDTypography color="success" textAlign="center" mb={2}>
              {success} You can now{" "}
              <MDTypography
                component={Link}
                to="/authentication/sign-in"
                color="info"
                fontWeight="medium"
                sx={{ textDecoration: "underline" }}
              >
                sign in
              </MDTypography>
              .
            </MDTypography>
          )}

          {/* STEP 1 */}
          {step === 1 && (
            <>
              <MDBox mb={4}>
                <MDInput
                  type="email"
                  label="Email"
                  variant="standard"
                  fullWidth
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </MDBox>

              <MDButton
                variant="gradient"
                color="info"
                fullWidth
                onClick={handleResetRequest}
                disabled={loading || !email}
              >
                {loading ? "Sending..." : "Reset Password"}
              </MDButton>
            </>
          )}

          {/* STEP 2 */}
          {step === 2 && (
            <>
              <MDBox mb={3}>
                <MDInput
                  type="text"
                  label="Verification Code"
                  variant="standard"
                  fullWidth
                  value={code}
                  onChange={(e) => setCode(e.target.value)}
                />
              </MDBox>

              <MDBox mb={4}>
                <MDInput
                  type="password"
                  label="New Password"
                  variant="standard"
                  fullWidth
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                />
              </MDBox>

              <MDButton
                variant="gradient"
                color="info"
                fullWidth
                onClick={handleCompleteReset}
                disabled={loading || !code || !newPassword}
              >
                {loading ? "Confirming..." : "Confirm Reset"}
              </MDButton>
            </>
          )}
        </MDBox>
      </Card>
    </BasicLayout>
  );
}

export default Cover;
